import { useFormik } from "formik";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { useTranslation } from "@i18n/hooks";

import {
	type ExternalLicenseFilterProps,
	type ExternalLicenseFilterState,
} from "./external-license-pool-table-filters.interface";
import { DefaultTextFieldComponent } from "../../../components/DefaultTextInput";
import { ValidatedField } from "../../../components/ValidatedField";

export const ExternalLicenseFilters = ({ refetch }: ExternalLicenseFilterProps) => {
	const { t } = useTranslation("common");

	const initialValues = {
		name: undefined,
		isIssued: undefined,
	};

	const formik = useFormik<ExternalLicenseFilterState>({
		initialValues,
		onSubmit: (values: ExternalLicenseFilterState, { setSubmitting }) => {
			refetch(values.isIssued, values.name);
			setSubmitting(false);
		},
	});

	const clearForm = () => {
		formik.handleReset(initialValues);
		formik.handleSubmit();
	};

	const dropdownOptions = [
		{ label: t("actions.yes"), value: true },
		{ label: t("actions.no"), value: false },
		{ label: t("externalLicenses.all"), value: null },
	];

	return (
		<form onSubmit={formik.handleSubmit} className="p-fluid">
			<div className="flex flex-row align-items-center">
				<ValidatedField<ExternalLicenseFilterState, string>
					name="name"
					label={t("table.name")}
					className="mr-2 mt-2"
					component={DefaultTextFieldComponent}
					formikConfig={formik}
				/>
				<div className="flex flex-column">
					<label>{t("externalLicenses.isIssued")}</label>
					<Dropdown
						className="m-1"
						options={dropdownOptions.map((o) => ({
							...o,
							label: `${t("externalLicenses.isIssued")}: ${o.label}`,
						}))}
						value={formik.values.isIssued}
						placeholder={t("externalLicenses.isIssued")}
						onChange={(e) => {
							formik.setFieldValue("isIssued", e.value);
						}}
					/>
				</div>
				<div className="mt-2">
					<Button
						disabled={false}
						type="reset"
						onClick={clearForm}
						icon="pi pi-times"
						className="h-3rem ml-auto"
					/>
					<Button
						disabled={false}
						type="submit"
						icon="pi pi-search"
						className="h-3rem ml-2"
					/>
				</div>
			</div>
		</form>
	);
};
